import VehicleListPage from '@/pages/vehicle/vehicle-list-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/vehicles/')({
  component: VehicleListPage,
});
